import { render } from "./TotalValueCount.vue?vue&type=template&id=2884a0b3"
import script from "./TotalValueCount.vue?vue&type=script&lang=js"
export * from "./TotalValueCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__